// import React, { useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min';

// const Carousel = () => {
//   useEffect(() => {
//     const bootstrap = require('bootstrap/dist/js/bootstrap.bundle.min');
//     const carouselElement = document.querySelector('#carouselExampleControls');
//     if (carouselElement) {
//       new bootstrap.Carousel(carouselElement, {
//         ride: 'carousel',
//         interval: 3000,  
//       });
//     }
//   }, []);

//   return (
//     <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
//       <div className="carousel-inner">
//         <div className="carousel-item active">
//           <img src="./images/slider/1.jpg" className="d-block w-100" alt="Slide 1" />
//         </div>
//         <div className="carousel-item">
//           <img src="./images/slider/2.jpg" className="d-block w-100" alt="Slide 2" />
//         </div>
//         <div className="carousel-item">
//           <img src="./images/slider/3.jpg" className="d-block w-100" alt="Slide 3" />
//         </div>
//         {/* <div className="carousel-item">
//           <img src="./images/slider/4.jpg" className="d-block w-100" alt="Slide 4" />
//         </div>
//         <div className="carousel-item">
//           <img src="./images/slider/5.jpg" className="d-block w-100" alt="Slide 5" />
//         </div>
//         <div className="carousel-item">
//           <img src="./images/slider/6.jpg" className="d-block w-100" alt="Slide 6" />
//         </div> 
//         */}
        
//       </div>
//       <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
//         <span className="carousel-control-prev-icon" aria-hidden="true"></span>
//         <span className="visually-hidden">Previous</span>
//       </button>
//       <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
//         <span className="carousel-control-next-icon" aria-hidden="true"></span>
//         <span className="visually-hidden">Next</span>
//       </button>
//     </div>
//   );
// };

// export default Carousel;













import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const Carousel = () => {
  useEffect(() => {
    const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.min");
    const carouselElement = document.querySelector("#videoCarousel");

    if (carouselElement) {
      new bootstrap.Carousel(carouselElement, {
        ride: "carousel",
        interval: false, 
      });
    }
  }, []);

  return (
    <div
      id="videoCarousel"
      className="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="false"
    >
      <div className="carousel-inner">

        <div className="carousel-item active video-slide">

          <video className="video-bg" autoPlay muted loop playsInline>
            <source src="./images/slider/videoo.mp4" type="video/mp4" />
          </video>

          <div className="video-buttons-overlay">
            <a href="/sedan" className="btn-slider-primary">Book a Car</a>
            <a href="/enquiry" className="btn-slider-outline">Inquiry</a>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Carousel;











// import React, { useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import "./VideoCarousel.css";

// const Carousel = () => {
//   useEffect(() => {
//     const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.min");
//     const carouselElement = document.querySelector("#videoCarousel");

//     if (carouselElement) {
//       new bootstrap.Carousel(carouselElement, {
//         ride: false,
//         interval: false,
//       });
//     }
//   }, []);

//   return (
//     <section className="hero-video-section">
//       <div
//         id="videoCarousel"
//         className="carousel slide"
//         data-bs-ride="false"
//       >
//         <div className="carousel-inner">
//           <div className="carousel-item active">
//             <div className="video-wrapper">

//               {/* VIDEO */}
//               <video
//                 className="hero-video"
//                 autoPlay
//                 muted
//                 loop
//                 playsInline
//               >
//                 <source src="/images/slider/videoo.mp4" type="video/mp4" />
//               </video>

//               {/* OVERLAY */}
//         <div className="video-wrapper">
//   {/* BACKGROUND VIDEO (BLUR FILL) */}
//   <video className="video-bg-blur" autoPlay muted loop playsInline>
//     <source src="/images/slider/videoo.mp4" type="video/mp4" />
//   </video>

//   {/* MAIN VIDEO (FULL – NO CUT) */}
//   <video className="hero-video" autoPlay muted loop playsInline>
//     <source src="/images/slider/videoo.mp4" type="video/mp4" />
//   </video>

//   <div className="video-overlay">
//     <a href="/sedan" className="btn-slider-primary">Book a Car</a>
//     <a href="/book-car" className="btn-slider-outline">Inquiry</a>
//   </div>
// </div>



//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Carousel;
